// Limites de tamanho do próprio WhatsApp — valem tanto para o Baileys quanto para a
// Cloud API da Meta. Acima deles o envio é recusado, e até o #15215 era recusado em
// SILÊNCIO: o anexo sumia do campo de digitação sem loader, sem confirmação e sem erro.
//
// Só o vídeo e o teto geral são conferidos aqui, de propósito. Imagem (5 MB) e áudio
// (16 MB) também têm limite, mas o que os atendentes mandam hoje passa — barrar na
// frente derrubaria envio que funciona. Quem quiser cobri-los acrescenta aqui.
export const LIMITE_VIDEO = 16 * 1024 * 1024;
export const LIMITE_DOCUMENTO = 100 * 1024 * 1024;

// A classificação é por EXTENSÃO, igual ao `prepararMidia` do backend
// (services/WbotServices/SendWhatsAppMedia.js): é ela que decide se o arquivo sai como
// vídeo ou como documento. Olhar o mimetype do navegador daria outra resposta — .mkv é
// "video/x-matroska" aqui e documento lá —, e a tela precisa prever o que o backend fará.
const EXTENSOES_VIDEO = ["mp4"];

const extensaoDe = arquivo =>
  String(arquivo?.name || "").split(".").pop().toLowerCase();

export const ehVideo = arquivo => EXTENSOES_VIDEO.includes(extensaoDe(arquivo));

// O que impede este arquivo de ser enviado como está:
//   null            → pode enviar normalmente
//   "acimaDoTeto"   → não há como enviar, nem como documento
//   "videoGrande"   → cabe como documento, mas não como vídeo
export const avaliarAnexo = arquivo => {
  const tamanho = arquivo?.size || 0;

  if (tamanho > LIMITE_DOCUMENTO) return "acimaDoTeto";
  if (ehVideo(arquivo) && tamanho > LIMITE_VIDEO) return "videoGrande";

  return null;
};

export const formatarTamanho = bytes => {
  const mb = (bytes || 0) / (1024 * 1024);
  if (mb >= 10) return `${Math.round(mb)} MB`;
  return `${mb.toFixed(1).replace(".", ",")} MB`;
};
